import { ChevronDownIcon, ChevronRightIcon } from "@storytell/bsky-icons";
import type { Operation } from "@storytell/streaming";
import { type Component, Show } from "solid-js";
import { Avatar } from "~/components/avatar/Avatar";
import { useWire } from "~/wire";

interface PromptOperationHeaderProps {
  operation: Operation;
  title: string;
  isExpanded: boolean;
  isProcessing: boolean;
  hasBlocks: boolean;
  onToggle: () => void;
}

/**
 * Special operation header for prompt acknowledgment operations.
 * Shows user avatar instead of task icon and uses a dotted line design.
 */
export const PromptOperationHeader: Component<PromptOperationHeaderProps> = (props) => {
  const wire = useWire();
  return (
    <div data-renderer="prompt-operation-header" class="flex items-start mb-4" data-operation={props.operation.id}>
      {/* User Avatar instead of checkmark/task icon */}
      <div class="flex-shrink-0 mr-6 w-[48] pl-2" style={{ width: "48px", "padding-left": "8px" }}>
        <Avatar src="/avatar/ag.png" name="Aaron Greenlee" size="sm" class="w-8 h-8 shadow-sm" />
      </div>

      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2 group">
          <button
            type="button"
            onClick={props.onToggle}
            class="text-base pt-1 font-medium text-gray-900 dark:text-gray-100 hover:text-gray-700 dark:hover:text-gray-300 transition-colors text-left"
          >
            {props.title}
          </button>

          <button
            type="button"
            onClick={props.onToggle}
            class="flex-shrink-0 p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
            title={props.isExpanded ? "Collapse prompt" : "Expand prompt"}
          >
            <Show
              when={props.isExpanded}
              fallback={<ChevronRightIcon size={16} class="text-gray-500 dark:text-gray-400" />}
            >
              <ChevronDownIcon size={16} class="text-gray-500 dark:text-gray-400" />
            </Show>
          </button>
        </div>

        {/* Status indicator for prompt acknowledgment */}
        <Show when={props.isProcessing}>
          <div class="mt-1 text-xs text-blue-600 dark:text-blue-400 font-medium">Prompt acknowledged</div>
        </Show>
      </div>
    </div>
  );
};
